import { defineStore } from "pinia";

interface State {
  tiptapConfig: {
    light?: boolean;
    showMergeTagText?: boolean;
  };
}

export const useTiptapConfigStore = defineStore("tiptapConfig", {
  state: (): State => ({
    tiptapConfig: {
      light: true,
    },
  }),

  actions: {
    setTiptapConfig(tiptapConfig: State["tiptapConfig"]) {
      this.tiptapConfig = tiptapConfig;
    },
  },
});
